




























































import Vue from "vue";
import Form from "@/components/Form.vue";

export default Vue.extend({
  name: "App",

  data: () => ({
    //
    name: null,
    email: null,
    message: null,
    nameRules: [
      (value: any) => !!value || "Required.",
      (value: any) => (value || "").length <= 20 || "Max 20 characters"
    ],
    messageRules: [
      (value: any) => !!value || "Required.",
      (value: any) => (value || "").length <= 520 || "Max 520 characters"
    ],
    emailRules: [
      (value: any) => !!value || "Required.",
      (value: any) => (value || "").length <= 20 || "Max 20 characters",
      (value: string) => {
        const pattern = /.+@.+/;
        return pattern.test(value) || "Invalid email address.";
      }
    ],
    valid: null
  })

});
